<nz-layout class="layout">
    <nz-sider nzCollapsible nzWidth="260px" [(nzCollapsed)]="isCollapsed" [nzTrigger]="null">
        <div [ngClass]="isCollapsed?'collapse-trigger':'collapse-menu'">
            <i class="trigger icon-color-trigger" nz-icon [nzType]="isCollapsed ? 'menu-unfold' : 'menu-fold'"
                (click)="collapseMenu()" style="z-index: auto;">
            </i>
        </div>
        <div class="hr"></div>
        <ul nz-menu nzMode="inline" class="mt-3">
            <li nz-menu-item class="icon-color" nzDisabled *ngIf="disableExpPass == true">
                <img nz-icon [hidden]="(clickedMenu === '1')" width="22" height="24" class="menu-icon" 
                    src="./assets/images/icon/SideMenu/verification_Blue.svg" alt="" nz-tooltip
                    nzTooltipTitle="{{'Util.01' | translate}}" nzTooltipPlacement="right"
                    [nzOverlayStyle]="isCollapsed ? {} : {display:'none'}">
                <span class="menu-text menu-font-size">{{'Util.01' | translate}}</span>
            </li>
            <li nz-menu-item class="icon-color" (click)="onClickNavigate('verification')" [nzSelected]="selected1" *ngIf="disableExpPass == false">
                <img nz-icon [hidden]="(clickedMenu === '1')" width="22" height="24" class="menu-icon"
                    src="./assets/images/icon/SideMenu/verification_Blue.svg" alt="" nz-tooltip
                    nzTooltipTitle="{{'Util.01' | translate}}" nzTooltipPlacement="right"
                    [nzOverlayStyle]="isCollapsed ? {} : {display:'none'}">
                <img nz-icon [hidden]="!(clickedMenu === '1')" width="22" height="24" class="menu-icon"
                    src="./assets/images/icon/SideMenu/verification_White.svg" alt="" nz-tooltip
                    nzTooltipTitle="{{'Util.01' | translate}}" nzTooltipPlacement="right"
                    [nzOverlayStyle]="isCollapsed ? {} : {display:'none'}">
                <span class="menu-text menu-font-size">{{'Util.01' | translate}}</span>
            </li>

            <li nz-menu-item class="icon-color" nzDisabled *ngIf="disableExpPass == true">
                <img nz-icon [hidden]="(clickedMenu === '2')" width="22" height="24" class="menu-icon"
                    src="./assets/images/icon/SideMenu/check-claim-processing_Blue.svg" alt="" nz-tooltip
                    nzTooltipTitle="{{'Util.02' | translate}}" nzTooltipPlacement="right"
                    [nzOverlayStyle]="isCollapsed ? {} : {display:'none'}">
                <span class="menu-text menu-font-size">{{'Util.02' | translate}}</span>
            </li>
            <li nz-menu-item class="icon-color" (click)="onClickNavigate('check-claim-processing')" [nzSelected]="selected2" *ngIf="disableExpPass == false">
                <img nz-icon [hidden]="(clickedMenu === '2')" width="22" height="24" class="menu-icon"
                    src="./assets/images/icon/SideMenu/check-claim-processing_Blue.svg" alt="" nz-tooltip
                    nzTooltipTitle="{{'Util.02' | translate}}" nzTooltipPlacement="right"
                    [nzOverlayStyle]="isCollapsed ? {} : {display:'none'}">
                <img nz-icon [hidden]="!(clickedMenu === '2')" width="22" height="24" class="menu-icon"
                    src="./assets/images/icon/SideMenu/check-claim-processing_White.svg" alt="" nz-tooltip
                    nzTooltipTitle="{{'Util.02'| translate}}" nzTooltipPlacement="right"
                    [nzOverlayStyle]="isCollapsed ? {} : {display:'none'}">
                <span class="menu-text menu-font-size">{{'Util.02' | translate}}</span>
            </li>

            <!-- <li nz-menu-item class="icon-color" nzDisabled *ngIf="disableExpPass == true">
                <img nz-icon [hidden]="(clickedMenu === '8')" width="22" height="24" class="menu-icon"
                    src="./assets/images/icon/SideMenu/concurrent-report_Blue.svg" alt="" nz-tooltip
                    nzTooltipTitle="{{'Util.10' | translate}}" nzTooltipPlacement="right"
                    [nzOverlayStyle]="isCollapsed ? {} : {display:'none'}">
                <span class="menu-text menu-font-size">{{'Util.10' | translate}}</span>
            </li>
            <li nz-menu-item class="icon-color" (click)="onClickNavigate('concurrent-report')" [nzSelected]="selected8"  *ngIf="disableExpPass == false">
                <img nz-icon [hidden]="(clickedMenu === '8')" width="22" height="24" class="menu-icon"
                    src="./assets/images/icon/SideMenu/concurrent-report_Blue.svg" alt="" nz-tooltip
                    nzTooltipTitle="{{'Util.10' | translate}}" nzTooltipPlacement="right"
                    [nzOverlayStyle]="isCollapsed ? {} : {display:'none'}">
                <img nz-icon [hidden]="!(clickedMenu === '8')" width="22" height="24" class="menu-icon"
                    src="./assets/images/icon/SideMenu/concurrent-report_White.svg" alt="" nz-tooltip
                    nzTooltipTitle="{{'Util.10'| translate}}" nzTooltipPlacement="right"
                    [nzOverlayStyle]="isCollapsed ? {} : {display:'none'}">
                <span class="menu-text menu-font-size">{{'Util.10' | translate}}</span>
            </li> -->
            

            <li nz-menu-item class="icon-color" nzDisabled *ngIf="disableExpPass == true">
                <img nz-icon [hidden]="(clickedMenu === '3')" width="22" height="24" class="menu-icon"
                    src="./assets/images/icon/SideMenu/check-money-transfers_Blue.svg" alt="" nz-tooltip
                    nzTooltipTitle="{{'Util.03' | translate}}" nzTooltipPlacement="right"
                    [nzOverlayStyle]="isCollapsed ? {} : {display:'none'}">
                <span class="menu-text menu-font-size">{{'Util.03' | translate}}</span>
            </li>
            <li nz-menu-item class="icon-color" (click)="onClickNavigate('check-money-transfers')" [nzSelected]="selected3" *ngIf="disableExpPass == false">
                <img nz-icon [hidden]="(clickedMenu === '3')" width="22" height="24" class="menu-icon"
                    src="./assets/images/icon/SideMenu/check-money-transfers_Blue.svg" alt="" nz-tooltip
                    nzTooltipTitle="{{'Util.03' | translate}}" nzTooltipPlacement="right"
                    [nzOverlayStyle]="isCollapsed ? {} : {display:'none'}">
                <img nz-icon [hidden]="!(clickedMenu === '3')" width="22" height="24" class="menu-icon"
                    src="./assets/images/icon/SideMenu/check-money-transfers_White.svg" alt="" nz-tooltip
                    nzTooltipTitle="{{'Util.03'| translate}}" nzTooltipPlacement="right"
                    [nzOverlayStyle]="isCollapsed ? {} : {display:'none'}">
                <span class="menu-text menu-font-size">{{'Util.03' | translate}}</span>
            </li>


            <li nz-menu-item class="icon-color" nzDisabled *ngIf="disableExpPass == true">
                <img nz-icon [hidden]="(clickedMenu === '4')" width="22" height="24" class="menu-icon"
                    src="./assets/images/icon/SideMenu/download_Blue.svg" alt="" nz-tooltip
                    nzTooltipTitle="{{'Util.04' | translate}}" nzTooltipPlacement="right"
                    [nzOverlayStyle]="isCollapsed ? {} : {display:'none'}">
                <span class="menu-font-size">{{'Util.04' | translate}}</span>
            </li>
            <li nz-menu-item class="icon-color" (click)="onClickNavigate('ดาวน์โหลด')" [nzSelected]="selected4" *ngIf="disableExpPass == false">
                <img nz-icon [hidden]="(clickedMenu === '4')" width="22" height="24" class="menu-icon"
                    src="./assets/images/icon/SideMenu/download_Blue.svg" alt="" nz-tooltip
                    nzTooltipTitle="{{'Util.04' | translate}}" nzTooltipPlacement="right"
                    [nzOverlayStyle]="isCollapsed ? {} : {display:'none'}">
                <img nz-icon [hidden]="!(clickedMenu === '4')" width="22" height="24" class="menu-icon"
                    src="./assets/images/icon/SideMenu/download_White.svg" alt="" nz-tooltip
                    nzTooltipTitle="{{'Util.04'| translate}}" nzTooltipPlacement="right"
                    [nzOverlayStyle]="isCollapsed ? {} : {display:'none'}">
                <span class="menu-font-size">{{'Util.04' | translate}}</span>
            </li>
            <!-- <li nz-menu-item class="icon-color" (click)="onClickNavigate('แสดงความคิดเห็น')" [nzSelected]="selected6">
                <img nz-icon [hidden]="(clickedMenu === '6')" width="22" height="24" class="menu-icon"
                    src="./assets/images/icon/SideMenu/feedback_Blue.svg" alt="" nz-tooltip
                    nzTooltipTitle="{{'Util.06' | translate}}" nzTooltipPlacement="right"
                    [nzOverlayStyle]="isCollapsed ? {} : {display:'none'}">
                <img nz-icon [hidden]="!(clickedMenu === '6')" width="22" height="24" class="menu-icon"
                    src="./assets/images/icon/SideMenu/feedback_White.svg" alt="" nz-tooltip
                    nzTooltipTitle="{{'Util.06'| translate}}" nzTooltipPlacement="right"
                    [nzOverlayStyle]="isCollapsed ? {} : {display:'none'}">
                <span class="menu-font-size menu-text">{{'Util.06' | translate}}</span>
            </li> -->

            <li nz-menu-item class="icon-color" (click)="onClickNavigate('change-password')" [nzSelected]="selected5"
                *ngIf="userType === '0'">
                <img nz-icon [hidden]="(clickedMenu === '5')" width="22" height="24" class="menu-icon"
                    src="./assets/images/icon/SideMenu/change-password_Blue.svg" alt="" nz-tooltip
                    nzTooltipTitle="{{'Util.05' | translate}}" nzTooltipPlacement="right"
                    [nzOverlayStyle]="isCollapsed ? {} : {display:'none'}">
                <img nz-icon [hidden]="!(clickedMenu === '5')" width="22" height="24" class="menu-icon"
                    src="./assets/images/icon/SideMenu/change-password_White.svg" alt="" nz-tooltip
                    nzTooltipTitle="{{'Util.05'| translate}}" nzTooltipPlacement="right"
                    [nzOverlayStyle]="isCollapsed ? {} : {display:'none'}">
                <span class="menu-text menu-font-size">{{'Util.05' | translate}}</span>
            </li>

            <li nz-menu-item class="icon-color" nzDisabled *ngIf="disableExpPass == true">
                <img nz-icon [hidden]="(clickedMenu === '7')" width="22" height="24" class="menu-icon"
                    src="./assets/images/icon/SideMenu/contact-medicare_Blue.svg" alt="" nz-tooltip
                    nzTooltipTitle="{{'Util.07' | translate}}" nzTooltipPlacement="right"
                    [nzOverlayStyle]="isCollapsed ? {} : {display:'none'}">
                <span class="menu-text menu-font-size">{{'Util.07' | translate}}</span>
            </li>
            <li nz-menu-item class="icon-color" (click)="onClickNavigate('contact-us')" [nzSelected]="selected7" *ngIf="disableExpPass == false">
                <img nz-icon [hidden]="(clickedMenu === '7')" width="22" height="24" class="menu-icon"
                    src="./assets/images/icon/SideMenu/contact-medicare_Blue.svg" alt="" nz-tooltip
                    nzTooltipTitle="{{'Util.07' | translate}}" nzTooltipPlacement="right"
                    [nzOverlayStyle]="isCollapsed ? {} : {display:'none'}">
                <img nz-icon [hidden]="!(clickedMenu === '7')" width="22" height="24" class="menu-icon"
                    src="./assets/images/icon/SideMenu/contact-medicare_White.svg" alt="" nz-tooltip
                    nzTooltipTitle="{{'Util.07'| translate}}" nzTooltipPlacement="right"
                    [nzOverlayStyle]="isCollapsed ? {} : {display:'none'}">
                <span class="menu-text menu-font-size">{{'Util.07' | translate}}</span>
            </li>
        </ul>
        <div class="log-out-to-buttom">
            <ul nz-menu nzMode="inline" [ngClass]="{'width-250': isCollapsed === false}">
                <li nz-menu-item nzDisabled [ngClass]="{'width-250': isCollapsed === false}" class="padding-0 pb-3">
                    <span class="logo-span">
                        <div *ngIf="languagesTHActive === true">
                            <label class="languageActive menu-font-size" (click)="changeLanguage('th')">TH</label> |
                            <label (click)="changeLanguage('en')">EN</label>
                        </div>
                        <div *ngIf="languagesTHActive === false">
                            <label class="menu-font-size" (click)="changeLanguage('th')">TH</label> | <label
                                class="languageActive" (click)="changeLanguage('en')">EN</label>
                        </div>
                    </span>
                </li>
                <br>
                <li nz-menu-item class="icon-color logout-holder" [ngClass]="{'collapse-logout-holder': isCollapsed}"
                    (click)="logout()">
                    <svg-icon nz-icon src="./assets/images/logout.svg" class="menu-icon"
                        [svgStyle]="{'width.px':18,'height.px':20}">
                    </svg-icon>
                    <span class="menu-font-size" *ngIf="!isCollapsed">
                        {{'logout' | translate}}
                    </span>
                </li>
            </ul>
        </div>
    </nz-sider>
    <nz-layout>
        <div class="header-content">
            <img class="banner-header" src="./assets/images/banner/banner-header.png">
            <img class="banner-header-logo" src="./assets/images/banner/logo.png">
        </div>
        <nz-content>
            <div nz-row>
                <div nz-col [hidden]="screenSize()" [nzSm]="11" nzLg="11" nzXl="11">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item menu-font-size"
                            *ngFor="let breadcrumb of breadcrumbList; let i = index"
                            [class.active]="i === breadcrumbList.length-1">
                            <!-- menu link-->
                            <a (click)="previousPage(breadcrumb.url)"
                                *ngIf="i !== breadcrumbList.length-1 && breadcrumb.label === 'หน้าแรก'">{{'Util.09' | translate}}</a>
                            <a (click)="previousPage(breadcrumb.url)"
                                *ngIf="i !== breadcrumbList.length-1 && breadcrumb.label === 'ตรวจสอบสิทธิ์'">{{'Util.01' | translate}}</a>
                            <a (click)="previousPage(breadcrumb.url)"
                                *ngIf="i !== breadcrumbList.length-1 && breadcrumb.label === 'ตรวจสอบผลการดำเนินการ'">{{'Util.02' | translate}}</a>
                            <a (click)="previousPage(breadcrumb.url)"
                                *ngIf="i !== breadcrumbList.length-1 && breadcrumb.label === 'ตรวจสอบการโอนเงิน'">{{'Util.03' | translate}}</a>
                            <a (click)="previousPage(breadcrumb.url)"
                                *ngIf="i !== breadcrumbList.length-1 && breadcrumb.label === 'รายละเอียดข้อมูลการโอนเงิน'">{{'Q0000.Q0014' | translate}}</a>
                            <a (click)="previousPage(breadcrumb.url)"
                                *ngIf="i !== breadcrumbList.length-1 && breadcrumb.label === 'ดาวน์โหลด'">{{'Util.04' | translate}}</a>
                            <a (click)="previousPage(breadcrumb.url)"
                                *ngIf="i !== breadcrumbList.length-1 && breadcrumb.label === 'เปลี่ยนรหัสผ่าน'">{{'Util.05' | translate}}</a>
                            <a (click)="previousPage(breadcrumb.url)"
                                *ngIf="i !== breadcrumbList.length-1 && breadcrumb.label === 'แสดงความติดเห็น'">{{'Util.06' | translate}}</a>
                            <a (click)="previousPage(breadcrumb.url)"
                                *ngIf="i !== breadcrumbList.length-1 && breadcrumb.label === 'ติดต่อไทยประกันชีวิตเมดิแคร์'">{{'Util.07' | translate}}</a>
                            <!-- menu label-->
                            <span
                                *ngIf="i === breadcrumbList.length-1 && breadcrumb.label === 'หน้าแรก'">{{'Util.09' | translate}}</span>
                            <span
                                *ngIf="i === breadcrumbList.length-1 && breadcrumb.label === 'ตรวจสอบสิทธิ์'">{{'Util.01' | translate}}</span>
                            <span
                                *ngIf="i === breadcrumbList.length-1 && breadcrumb.label === 'ตรวจสอบผลการดำเนินการ'">{{'Util.02' | translate}}</span>
                            <span
                                *ngIf="i === breadcrumbList.length-1 && breadcrumb.label === 'ตรวจสอบการโอนเงิน'">{{'Util.03' | translate}}</span>
                            <span
                                *ngIf="i === breadcrumbList.length-1 && breadcrumb.label === 'รายละเอียดข้อมูลการโอนเงิน'">{{'Q0000.Q0014' | translate}}</span>
                            <span
                                *ngIf="i === breadcrumbList.length-1 && breadcrumb.label === 'ดาวน์โหลด'">{{'Util.04' | translate}}</span>
                            <span
                                *ngIf="i === breadcrumbList.length-1 && breadcrumb.label === 'เปลี่ยนรหัสผ่าน'">{{'Util.05' | translate}}</span>
                            <span
                                *ngIf="i === breadcrumbList.length-1 && breadcrumb.label === 'แสดงความติดเห็น'">{{'Util.06' | translate}}</span>
                            <span
                                *ngIf="i === breadcrumbList.length-1 && breadcrumb.label === 'ติดต่อไทยประกันชีวิตเมดิแคร์'">{{'Util.07' | translate}}</span>
                            <span
                                *ngIf="i === breadcrumbList.length-1 && breadcrumb.label === 'รายงานอาการผู้เอาประกันภัย'">{{'Util.10' | translate}}</span>
                            <!-- submenu label -->
                            <span
                                *ngIf="i === breadcrumbList.length-1 && breadcrumb.label === 'ผลการตรวจสอบสิทธิ์ OPD'">{{'E0000.E0001' | translate}}</span>
                            <span
                                *ngIf="i === breadcrumbList.length-1 && breadcrumb.label === 'ผลการตรวจสอบสิทธิ์ IPD'">{{'C0000.C0001' | translate}}</span>
                            <span
                                *ngIf="i === breadcrumbList.length-1 && breadcrumb.label === 'แจ้งค่ารักษา OPD'">{{'F0000.F0001' | translate}}</span>
                        </li>
                    </ol>
                </div>
                <div nz-col [nzSm]="24" [nzMd]="textName" nzLg="textName" nzXl="13" class="text-banner">
                    <div nz-row class="right">
                        <div class="text-name menu-font-size">{{name}}</div>
                        <div class="hr-left"></div>
                        <div class="text-titel-hospital menu-font-size">{{'Util.08' | translate}} : </div>
                        <div class="text-hospital menu-font-size">{{hospital}}</div>
                    </div>
                </div>
            </div>
            <router-outlet></router-outlet>
        </nz-content>
        <nz-footer>Copyright © Thai Life Insurance Public Company Limited. All Rights Reserved</nz-footer>
    </nz-layout>
</nz-layout>

<app-announce-password [isVisible]="announcePassword" [daysRemaining]="daysRemaining" (closeModal)="closeModalAnnounce($event)">
</app-announce-password>
<app-expire-password [isVisible]="expirePassword" (closeModal)="closeModalExpire($event)">
</app-expire-password>